import { gql } from "@apollo/client";

const USER_SUMMARY_FRAGMENT = gql`
  fragment UserSummary on User {
    id
    email
    name @client
    logo @client
    firstName
    lastName
    products
    companyRoles
    permissions
    removedPermissions
  }
`;

export default USER_SUMMARY_FRAGMENT;
